const API_BASE = '/api/v1/public/projects';
const VSJ_SLUG = 'valor-san-juan';

export type ValuationPropertyType = 'house' | 'apartment' | 'land';
export type ValuationCondition    = 'to_renovate' | 'good' | 'very_good' | 'brand_new';
export type ValuationAgeBucket    = 'brand_new' | 'lt_10' | '10_to_30' | 'gt_30';

export interface CreateValuationSessionBody {
  placeToken:   string;
  lng:          number;
  lat:          number;
  propertyType: ValuationPropertyType;
  areaLandM2:   number | null;
  areaBuiltM2:  number | null;
  streetLabel?: string | null;
}

export interface UpdateValuationSessionBody {
  rooms?:          number | null;
  bedrooms?:       number | null;
  bathrooms?:      number | null;
  condition?:      ValuationCondition | null;
  ageYearsBucket?: ValuationAgeBucket | null;
  garage?:         boolean | null;
  patio?:          boolean | null;
  pool?:           boolean | null;
}

export interface ValuationSessionResponse {
  sessionToken: string;
}

export async function createValuationSession(
  body: CreateValuationSessionBody,
): Promise<ValuationSessionResponse> {
  const res = await fetch(`${API_BASE}/${VSJ_SLUG}/valuations`, {
    method:  'POST',
    headers: { 'Content-Type': 'application/json' },
    body:    JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`create-session: HTTP ${res.status}`);
  return res.json() as Promise<ValuationSessionResponse>;
}

export async function updateValuationSession(
  sessionToken: string,
  body: UpdateValuationSessionBody,
): Promise<ValuationSessionResponse> {
  const res = await fetch(`${API_BASE}/${VSJ_SLUG}/valuations/${sessionToken}`, {
    method:  'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body:    JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`update-session: HTTP ${res.status}`);
  return res.json() as Promise<ValuationSessionResponse>;
}
